import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import OccupationalHealth from '../../models/core/occupationalHealth/OccupationalHealth';
import { FETCH_OCCUPATIONAL_HEALTH } from '../actions/occupationalHealth';
 
interface IOccupationalHealthReducer{ 
    occupHealthList: OccupationalHealth[]
}
 
const initialState: IOccupationalHealthReducer = {
    occupHealthList: []
} 
 
export const OccupationalHealthReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case FETCH_OCCUPATIONAL_HEALTH:{
            return {
                ...cloneDeep(state),
                occupHealthList: action.occupHealthList
            }
        }
       default:{
           return state
       }
   }
}
 